import adminApiFetch from './apiService';

export const partnerApiLogService = {
  getList: async (params) => {
    const query = new URLSearchParams(params).toString();
    const response = await adminApiFetch(`partner_api_logs?${query}`);
    return response.json();
  },
  getRecords: async (params) => {
    const response = await adminApiFetch('partner_api_logs/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },
  get: async (id) => {
    const response = await adminApiFetch(`partner_api_logs/${id}`);
    return response.json();
  },
};
